import React__default from 'react';
import { useModalState } from './use_modal_state.js';
import { getHeadingId } from './utils.js';
import '../heading/index.js';
import { Heading } from '../heading/heading.js';

const ModalHeading = (props) => {
    const state = useModalState();
    return React__default.createElement(Heading, { size: "large", ...props, id: getHeadingId(state.id) });
};

export { ModalHeading };
